import { render, staticRenderFns } from "./MoreOverview.vue?vue&type=template&id=82d02b3c&scoped=true&"
import script from "./MoreOverview.vue?vue&type=script&lang=js&"
export * from "./MoreOverview.vue?vue&type=script&lang=js&"
import style0 from "./MoreOverview.vue?vue&type=style&index=0&id=82d02b3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d02b3c",
  null
  
)

export default component.exports